import { MessageSchema } from '../../realm/schema';
import { useAppNavigation } from '../navigation';
import { Pressable, StyleSheet, Text, View, Platform } from 'react-native';
import { black, color_333333, color_666666, color_main, white, primary50 } from '../../assets/style/colors';
import { getUserName } from './chat-helper';
import { getMsgContent } from '../../utils/utils';
import { Str_ChatRecord, Str_ErrorChatRecord } from '../../language/string_res';
import { ContentRenderProps } from './ContentRender';
import { useChatStore } from '../../store/ChatStore';
import { useWindowDimensions } from 'react-native';
import IconSpeech from '../../assets/svg/icon_speech.svg';

export const TalkContentRender = (props: ContentRenderProps) => {
	const { width: screenWidth } = useWindowDimensions();
	const navigation = useAppNavigation();

	let lock = false;
	if (props.item.content === '') {
		return <Text style={{ color: color_333333 }}>{Str_ErrorChatRecord}</Text>;
	}
	try {
		let { title, selectMessages } = JSON.parse(props.item.content);
		if (!selectMessages) {
			return <Text style={{ color: color_333333 }}>{Str_ErrorChatRecord}</Text>;
		}
		const content = (latestMessage: any) => {
			if (!latestMessage) {
				return null;
			}
			const content = getMsgContent(latestMessage.type, latestMessage.content);
			return <Text style={styles.talkViewContentText} numberOfLines={1}>{content}</Text>;
		};

		const handlePreview = () => {
			if (props.talkSelectStatus === true) {
				props.onClick?.();
				return;
			}
			if (!lock) {
				lock = true;
				// 跳转聊天详情展示页面
				navigation.push('ChatTalk', { tid: props.item.tid, title: title, selectMessages: selectMessages });
				setTimeout(() => {
					lock = false;
				}, 2000);
			}
		};
		const styles = getStyles(screenWidth);
		const isSelf = props.isSelf;

		return selectMessages ? (
			<Pressable style={{ maxWidth: "100%", flexShrink: 1 }}
				onPress={handlePreview}
				onLongPress={props.onLongPress}
				disabled={props.talkSelectStatus === true}>
				<View style={[styles.talkView]}>
					{/* 顶部：图标 + 标题 */}
					<View style={styles.talkViewHeader}>
						<Text style={[styles.talkViewTitle, isSelf && styles.talkViewTitleSelf]} numberOfLines={1}>
							{title}
						</Text>
					</View>

					{/* 消息预览区域 */}
					<View style={styles.talkViewContent}>
						{selectMessages.slice(0, selectMessages.length <= 3 ? selectMessages.length : 3).map((talk: MessageSchema, index: number) => {
							const userName = talk.user?.nick || talk.user?.name || talk.user?.remark || '';
							const contentResult = content(talk);
							return (
								<View key={index} style={styles.messageRow}>
									<Text style={styles.userName} numberOfLines={1}>{userName}</Text>
									<Text style={styles.separator}>: </Text>
									{contentResult}
								</View>
							);
						})}
						{selectMessages.length > 3 && (
							<Text style={styles.moreText}>+{selectMessages.length - 3} 条消息</Text>
						)}
					</View>

					{/* 底部：标签 */}
					<View style={styles.talkViewFooter}>
						<View style={[styles.footerTag, isSelf && styles.footerTagSelf]}>
							<Text style={[styles.footerText, isSelf && styles.footerTextSelf]}>{Str_ChatRecord}</Text>
						</View>
					</View>
				</View>
			</Pressable>
		) : null;
	} catch (error) {
		return <Text style={{ color: color_333333 }}>{Str_ErrorChatRecord}</Text>;
	}
};

const getStyles = (screenWidth: number) => StyleSheet.create({
	talkView: {
		borderRadius: 12,
		minWidth: 220,
		padding: 12,
	},
	talkViewHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 10,
		paddingBottom: 8,
		borderBottomWidth: 1,
		borderBottomColor: primary50,
	},
	headerIcon: {
		marginRight: 8,
	},
	headerIconSelf: {
		marginRight: 8,
	},
	talkViewTitle: {
		flex: 1,
		fontSize: 15,
		fontWeight: '600',
		color: color_333333,
	},
	talkViewTitleSelf: {
		color: white,
	},
	talkViewContent: {
		minHeight: 48,
	},
	messageRow: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 6,
		borderRadius: 6,
		paddingHorizontal: 8,
		paddingVertical: 4,
		backgroundColor: 'rgba(0,0,0,0.05)',
	},
	userName: {
		fontSize: 13,
		fontWeight: '500',
		color: color_666666,
		maxWidth: '35%',
	},
	separator: {
		fontSize: 13,
		color: color_666666,
	},
	talkViewContentText: {
		flex: 1,
		fontSize: 13,
		color: color_333333,
	},
	talkViewFooter: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		marginTop: 8,
		paddingTop: 8,
		borderTopWidth: 1,
		borderTopColor: primary50,
	},
	footerTag: {
		backgroundColor: primary50,
		paddingHorizontal: 10,
		paddingVertical: 4,
		borderRadius: 10,
	},
	footerTagSelf: {
		backgroundColor: 'rgba(255,255,255,0.2)',
	},
	footerText: {
		fontSize: 11,
		color: color_main,
		fontWeight: '500',
	},
	footerTextSelf: {
		color: white,
	},
	moreText: {
		fontSize: 12,
		color: color_main,
		marginTop: 4,
	},
});
